import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HelperService, DateService, DataService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';

import { environment } from 'environments/environment';

@Component({
  selector: 'app-oil-change-dialog',
  templateUrl: './oil-change-dialog.component.html',
  styleUrls: ['./oil-change-dialog.component.scss'],
})
export class OilChangeDialogComponent implements OnInit {
  date: any = {};
  endDate: any;
  start: any;
  vehicle: any = {};
  vehicleinfo: any = {};
  vehicleYmm: string = '';
  odoMeter: string = '';
  nextServiceMiles: number = 0;
  defaultNextServiceMiles: number = 0;
  isFilterChange: boolean = true;
  measuringLabel: string = '';
  measuringUnitOnly: string = '';
  min = new Date();
  validate: any = {};
  isOilStickerImproved: boolean = true;
  currentLang: string = 'en';
  companyLocalization: boolean = false;

  // Array of oil change pills, each with a label and km/mi value
  oilChangePills = [
    { label: '3 months /', km: 5000, mi: 3000, interval: 3 },
    { label: '5 months /', km: 10000, mi: 8000, interval: 5 },
    { label: '6 months /', km: 12000, mi: 10000, interval: 6 },
    { label: '12 months /', km: 15000, mi: 12000, interval: 12 }
  ];
  activePillIndex = 0;

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dateService: DateService,
    private helperService: HelperService,
    private dialogConfig: DynamicDialogConfig,
    public dataService: DataService
  ) {}

  // field errors
  public fieldErrors = {
    bin: '',
  };

  ngOnInit() {
    this.min = new Date();
    const data = this.helperService.deepCopy(this.dialogConfig.data);
    this.endDate = data.endDate;
    this.date = this.dateService.addDaysInDatetime(new Date(), 3, 'months', datetimeFormat.mmmdyyyy);
    this.vehicleinfo = data.vehicle;
    if (data.localization) {
      this.companyLocalization = data.localization;
      this.currentLang = data.lang;
    }
    this.vehicleYmm = `${data.vehicle.year} ${data.vehicle.make} ${data.vehicle.model}`;
    this.odoMeter = `${data.odoMeter}`;
    this.measuringLabel = `Mileage ${data.mileageMeasuringUnit}`;
    this.measuringUnitOnly = `${data.mileageMeasuringUnit}`;
    this.nextServiceMiles = this.measuringUnitOnly === 'km' ? data.odoMeter + 5000 : data.odoMeter + 3000;
    this.defaultNextServiceMiles = this.helperService.deepCopy(this.nextServiceMiles);
    this.isOilStickerImproved = this.dataService.isOilStickerImproved;
  }


  // Handle oil change pill click
  onOilChangePillClick(index: number): void {
    this.activePillIndex = index;
    const today = new Date();
    const dateInterval = new Date(today.setMonth(today.getMonth() + this.oilChangePills[index].interval));
    if (this.measuringUnitOnly === 'km') {
      this.nextServiceMiles = this.oilChangePills[index].km + Number(this.odoMeter);
    } else {
      this.nextServiceMiles = this.oilChangePills[index].mi + Number(this.odoMeter);
    }
    this.date = dateInterval;
  }

  close(type?: boolean) {
    this.dynamicDialogRef.close(type);
  }

  public handleChange(name: string, value: any): void {
    this.nextServiceMiles = value;
    this.validateFields();
  }

  /**
   * Validate all fields
   */
  private validateFields(): boolean {
    try {
      let isValid: boolean = true;
      this.activePillIndex = null;

      if (!this.nextServiceMiles) {
        this.fieldErrors.bin = 'Mileage is required';
        isValid = false;
      } else if (this.nextServiceMiles && Number(this.nextServiceMiles) <= Number(this.odoMeter)) {
        this.fieldErrors.bin = `Mileage should be greater than ${this.odoMeter}`;
        isValid = false;
      } else {
        this.fieldErrors.bin = '';
      }
      return isValid;
    } catch (error) {
      console.error(error);
      this.helperService.showToaster('error', error);
      return false;
    }
  }

  printOilSticker() {
    // validate form fields
    if (!this.validateFields()) return;

    const printSample = {
      printRO: true,
      isOilStickerImproved: this.isOilStickerImproved,
    };

    let url = `/#/customer-review/oil-change/print?date=${this.dateService.formatDate(new Date(this.date), this.currentLang === 'fr' ? datetimeFormat.mmmmdyyyy : datetimeFormat.mmmdyyyy, this.companyLocalization ? this.currentLang : "en")}&mileage=${this.odoMeter
      }&lang=${this.companyLocalization ? this.currentLang : 'en'}&nextMileage=${this.nextServiceMiles}&measuringUnit=${this.measuringUnitOnly}&name=${this.vehicleYmm}&filterChange=${this.isFilterChange}&printSample=${JSON.stringify(printSample)}`;
    const myWindow = window.open(url, '_blank');
    myWindow.focus();
  }
}
